import { render, staticRenderFns } from "./IssueTickets.vue?vue&type=template&id=7dc12bc4&scoped=true&"
import script from "./IssueTickets.vue?vue&type=script&lang=js&"
export * from "./IssueTickets.vue?vue&type=script&lang=js&"
import style0 from "./IssueTickets.vue?vue&type=style&index=0&id=7dc12bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc12bc4",
  null
  
)

export default component.exports